import { DataService } from 'api/DataService'
import type {
  Email,
  Sms,
  Whats
} from 'templates/Settings/Body/Sections/Notifications/context/Notifications.interface'

export interface PriceNotifications {
  email_fee: any
  sms_fee: any
  whatsapp_fee: any
  email_enabled?: boolean
  whatsapp_enabled?: boolean
  // Coexistence ativo: o envio de WhatsApp sai pelo WABA do merchant e não é
  // cobrado, então o custo desse canal não deve ser exibido.
  whatsapp_coexistence_active?: boolean
}

export interface PayloadExtraNotification {
  extra_type: string
  days: number
  name: string
  notification_rules: {
    sms: Partial<Sms>
    email: Partial<Email>
    whats: Partial<Whats>
    is_active: boolean
  }
}

export interface PayloadDefaultNotification {
  category: string
  item: string
  notification_rules: {
    is_active: boolean
    sms: {
      message: string | null
      is_active: boolean
    }
    email: {
      subject: string | null
      message: string | null
      is_active: boolean
    }
    whats?: {
      message: string | null
      is_active: boolean
    }
  }
}

export interface PayloadDaysIssueBilling {
  days_to_issue_billing: number
  issue_billing_type?: string
}

export interface PayloadUpdateRule {
  ruler_type: string
}

export interface PayloadRulesActive {
  items?: { category: string; item: string; active: boolean }[]
  extra_notifications?: { uuid: string; active: boolean }[]
  days_to_issue_billing?: number
  issue_billing_type?: string
  ruler_type?: string
  base_type?: string
  refresh_billings?: boolean
}

export interface GeneralSettings {
  business_days_only_messages: boolean
  limit_days_for_payment: number
  reply_to_email: string
}

export interface PayloadGeneralSettings {
  business_days_only_messages?: boolean
  limit_days_for_payment?: number
  reply_to_email?: string
  // SC-11742: prazo padrão de negativação (área Negativação da régua).
  default_days_to_report?: number
}

export class BillingRule {
  public static async getConfigurationsNotifications() {
    const response = await DataService({
      type: 'GET',
      url: `/v1/billing_rulers/notification_rules`
    })

    if (response.status === 200) {
      return response?.data
    }

    return {} as any
  }
  public static async createNewExtraNotification(
    dataForm: PayloadExtraNotification
  ) {
    const response = await DataService({
      type: 'POST',
      url: `/v1/billing_rulers/extra_notification`,
      data: dataForm
    })

    if (response.status === 200) {
      return response?.data
    }

    return response
  }
  public static async updateExtraNotification(
    uuid: string,
    dataForm: PayloadExtraNotification
  ) {
    const response = await DataService({
      type: 'PATCH',
      url: `/v1/billing_rulers/extra_notification/${uuid}`,
      data: dataForm
    })

    if (response.status === 200) {
      return response?.data
    }

    return response
  }
  public static async getPriceNotifications(): Promise<{
    error?: boolean
    message?: string
    record?: PriceNotifications
  }> {
    const response = await DataService({
      type: 'GET',
      url: `/v1/billing_rulers/extra_notification/fees`
    })

    if (response.status === 200) {
      return response?.data
    }

    return {} as any
  }
  public static async getExtraNotificationByUUID(uuid: string) {
    const response = await DataService({
      type: 'GET',
      url: `/v1/billing_rulers/extra_notification/${uuid}`
    })

    if (response.status === 200) {
      return response?.data
    }

    return {} as any
  }
  public static async deleteNotification(uuid: string) {
    const response = await DataService({
      type: 'DELETE',
      url: `/v1/billing_rulers/extra_notification/${uuid}`
    })

    if (response.status === 200) {
      return response?.data
    }

    return {} as any
  }
  public static async editDefaultNotification(
    payload: PayloadDefaultNotification
  ) {
    const response = await DataService({
      type: 'PATCH',
      url: `/v1/billing_rulers/customize_notification_rules`,
      data: payload
    })

    if (response.status === 200) {
      return response?.data
    }

    return response
  }
  public static async updateDaysIssueBilling(payload: PayloadDaysIssueBilling) {
    const response = await DataService({
      type: 'PATCH',
      url: `/v1/billing_rulers/days_to_issue_billing`,
      data: payload
    })

    if (response.status === 200) {
      return response?.data
    }

    return response
  }
  public static async updateRule(payload: PayloadUpdateRule) {
    const response = await DataService({
      type: 'PATCH',
      url: `/v1/billing_rulers`,
      data: payload
    })

    if (response.status === 200) {
      return response?.data
    }

    return response
  }
  public static async updateRulesActive(payload: PayloadRulesActive) {
    const response = await DataService({
      type: 'PATCH',
      url: `/v1/billing_rulers/active`,
      data: payload
    })

    if (response.status === 200) {
      return response?.data
    }

    return response
  }
  public static async getConfigurationRule(payload: string) {
    const response = await DataService({
      type: 'GET',
      url: `/v1/billing_rulers/notification_rules/${payload}`
    })

    if (response.status === 200) {
      return response?.data
    }

    return response
  }

  public static async getGeneralSettings() {
    const response = await DataService({
      type: 'GET',
      url: `/v1/merchants/perfil`
    })

    if (response.status === 200) {
      return response?.data
    }

    return {} as any
  }

  public static async updateGeneralSettings(payload: PayloadGeneralSettings) {
    const response = await DataService({
      type: 'PATCH',
      url: `/v1/merchant_preferences`,
      data: payload
    })

    return response?.data || response
  }
}
